import ThemeManager from "./ThemeManager";

export default ThemeManager;
